import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  ActionHelper,
  OnyxAvatarComponent,
  OnyxIconButtonComponent,
  OnyxPhonePipe,
  OnyxTooltipDirective,
} from '@onyx/angular';
import type { OutsourcingDriver } from '../../interfaces/order';

@Component({
  selector: 'app-order-outsourcing-driver',
  imports: [
    OnyxIconButtonComponent,
    OnyxTooltipDirective,
    TranslatePipe,
    OnyxPhonePipe,
    OnyxAvatarComponent,
  ],
  templateUrl: './order-outsourcing-driver.component.html',
  styleUrl: './order-outsourcing-driver.component.scss',
})
export class OrderOutsourcingDriverComponent {
  public readonly driver = input.required<OutsourcingDriver>();

  protected readonly ActionHelper = ActionHelper;
}
